module.exports = __webpack_public_path__ + "static/img/home.620f0a79.png";